// extracted by mini-css-extract-plugin
export var carrierNotice = "_jz-5";
export var carrierNoticePlaceholder = "_jz-6";
export var deliveryRow = "_jz-c";
export var fixedHeight = "_jz-4";
export var freightLogo = "_jz-b";
export var fullWidth = "_jz-3";
export var priceColumn = "_jz-7";
export var radioSelected = "_jz-9";
export var radioUnselected = "_jz-8";
export var selectedOption = "_jz-2";
export var selectedOptionContainer = "_jz-1";
export var selection = "_jz-0";
export var tallSkeletonText = "_jz-a";